import React from "react";
import LegalPage from "./LegalPage";
import { BRAND } from "../lib/site";

export default function TermsPage() {
  return (
    <LegalPage title="Terms of Service" kicker="Legal" testid="page-terms">
      <h2 className="font-heading text-3xl text-white">1. Acceptance of Terms</h2>
      <p>
        By accessing or using the website {BRAND.domain} ("Site"), you
        agree to be bound by these Terms of Service. If you do not agree,
        please discontinue use of the Site.
      </p>

      <h2 className="font-heading text-3xl text-white">2. Not Medical Advice</h2>
      <p>
        Information presented on this Site is for general educational
        purposes only and does not constitute medical advice, diagnosis
        or treatment. No physician-patient relationship is established
        through use of the Site. Surgical decisions are made only after
        an in-person consultation and signed informed consent.
      </p>

      <h2 className="font-heading text-3xl text-white">3. Eligibility</h2>
      <p>
        You must be at least 18 years of age to schedule a consultation
        or undergo any elective cosmetic procedure with {BRAND.name}.
      </p>

      <h2 className="font-heading text-3xl text-white">4. Consultation Requests</h2>
      <p>
        Submission of a consultation request form does not guarantee an
        appointment. All requests are subject to review, scheduling
        availability and clinical screening.
      </p>

      <h2 className="font-heading text-3xl text-white">5. Intellectual Property</h2>
      <p>
        All trademarks, logos, photographs, text and design elements on
        the Site are the property of {BRAND.name} or our licensors.
        Unauthorised reproduction or redistribution is prohibited.
      </p>

      <h2 className="font-heading text-3xl text-white">6. Patient Imagery</h2>
      <p>
        Before-and-after images displayed on the Site are published only
        with written patient consent. Individual results vary; no
        specific outcome is guaranteed.
      </p>

      <h2 className="font-heading text-3xl text-white">7. Third-Party Links</h2>
      <p>
        The Site may link to third-party resources (such as the NPI
        Registry). We are not responsible for content or practices of
        external sites.
      </p>

      <h2 className="font-heading text-3xl text-white">8. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, {BRAND.name} shall not be
        liable for any indirect, incidental, special or consequential
        damages arising from your use of the Site.
      </p>

      <h2 className="font-heading text-3xl text-white">9. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the State of North Carolina,
        without regard to its conflict of law provisions.
      </p>

      <h2 className="font-heading text-3xl text-white">10. Modifications</h2>
      <p>
        We may revise these Terms at any time. Continued use of the Site
        after changes are posted constitutes acceptance.
      </p>
    </LegalPage>
  );
}
